(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfex-v2-anuncios"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('perfex-announcement')) {
 customElements.define('perfex-announcement', class extends HTMLElement {
   connectedCallback() {
     this.updateHeight = () => {
       if (!this.isConnected) return;
       const height = Math.ceil(this.getBoundingClientRect().height);
       this.lastHeight = height + 'px';
       document.documentElement.style.setProperty('--announcement-height', this.lastHeight);
     };
     this.frame = requestAnimationFrame(this.updateHeight);
     if ('ResizeObserver' in window) {
       this.observer = new ResizeObserver(this.updateHeight);
       this.observer.observe(this);
     } else {
       window.addEventListener('resize', this.updateHeight);
     }
   }
   disconnectedCallback() {
     cancelAnimationFrame(this.frame);
     if (this.observer) this.observer.disconnect();
     window.removeEventListener('resize', this.updateHeight);
     if (!document.querySelector('perfex-announcement')) {
       document.documentElement.style.setProperty('--announcement-height', '0px');
       document.documentElement.style.setProperty('--ann-height', '0px');
     }
   }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfex-v2-sistema"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('perfex-system-builder')) {
  customElements.define('perfex-system-builder', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.clickHandler) this.removeEventListener('click', this.clickHandler);
      if (this.changeHandler) this.removeEventListener('change', this.changeHandler);
      this.initialized = false;
    }
    init() {
      if (this.initialized || !this.querySelector('[data-selection]')) return;
      this.initialized = true;
      this.busy = Boolean(this.busy);
      this.locked = Boolean(this.locked);
      this.rows = [...this.querySelectorAll('[data-row]')];
      const seen = new Set();
      this.rows = this.rows.filter(row => {
        const id = Number(row.dataset.variant);
        const price = Number(row.dataset.price);
        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(price) || price < 0 || seen.has(row.dataset.product)) {
          row.hidden = true;
          return false;
        }
        seen.add(row.dataset.product);
        return true;
      });
      this.list = this.querySelector('[data-selection]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error]');
      this.purchaseButtons = [...this.querySelectorAll('[data-purchase]')];
      try {
        this.money = new Intl.NumberFormat(this.dataset.locale || 'es', {
          style:'currency', currency:this.dataset.currency || 'EUR'
        });
      } catch (_) {
        this.money = new Intl.NumberFormat('es', {style:'currency', currency:'EUR'});
      }
      this.clickHandler = event => this.handleClick(event);
      this.changeHandler = event => {
        if (event.target.matches('[data-quantity]')) {
          if (this.busy || this.locked) return;
          this.status.textContent = '';
          this.render();
        }
      };
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('change', this.changeHandler);
      this.render();
    }
    format(value) { return this.money.format(value / 100); }
    quantity(row) {
      const input = row.querySelector('[data-quantity]');
      const value = Number(input.value);
      const maximum = Math.max(0, Number(input.max) || 99);
      const result = Number.isFinite(value) ? Math.min(maximum, Math.max(0, Math.floor(value))) : 0;
      input.value = String(result);
      return result;
    }
    selection() {
      return this.rows.map(row => ({
        row,
        id:Number(row.dataset.variant),
        product:row.dataset.product,
        name:row.dataset.name,
        price:Number(row.dataset.price),
        quantity:this.quantity(row)
      })).filter(item => item.quantity > 0);
    }
    render() {
      const items = this.selection();
      const subtotal = items.reduce((total, item) => total + item.price * item.quantity, 0);
      const unitCount = items.reduce((total, item) => total + item.quantity, 0);
      const saving = this.dataset.discountEnabled === 'true' && unitCount >= 2 ? Math.round(subtotal * .10) : 0;
      this.list.replaceChildren();
      items.forEach(item => {
        const line = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('span');
        name.textContent = item.name + ' × ' + item.quantity;
        price.textContent = this.format(item.price * item.quantity);
        line.append(name, price);
        this.list.append(line);
      });
      this.querySelector('[data-empty]').hidden = items.length > 0;
      this.querySelector('[data-subtotal]').textContent = this.format(subtotal);
      this.querySelector('[data-saving-row]').hidden = saving === 0;
      this.querySelector('[data-saving]').textContent = '−' + this.format(saving);
      this.querySelector('[data-total]').textContent = this.format(subtotal - saving);
      this.rows.forEach(row => {
        const input = row.querySelector('[data-quantity]');
        const quantity = Number(input.value);
        input.disabled = this.busy || this.locked;
        row.querySelector('[data-step="-1"]').disabled = this.busy || this.locked || quantity <= 0;
        row.querySelector('[data-step="1"]').disabled = this.busy || this.locked || quantity >= Number(input.max);
      });
      this.purchaseButtons.forEach(button => button.disabled = this.busy || this.locked || items.length === 0);
      this.setAttribute('aria-busy', String(this.busy));
    }
    handleClick(event) {
      const step = event.target.closest('[data-step]');
      if (step && this.contains(step)) {
        if (step.disabled || this.busy || this.locked) return;
        const row = step.closest('[data-row]');
        const input = row.querySelector('[data-quantity]');
        input.value = String(this.quantity(row) + Number(step.dataset.step));
        this.status.textContent = '';
        this.render();
        return;
      }
      const purchase = event.target.closest('[data-purchase]');
      if (purchase && this.contains(purchase) && !purchase.disabled) this.purchase(purchase.dataset.purchase);
    }
    async purchase(destination) {
      if (this.busy || this.locked) return;
      const items = this.selection().map(item => ({id:item.id, quantity:item.quantity}));
      if (!items.length) return;
      this.busy = true;
      this.error.hidden = true;
      this.status.textContent = 'Añadiendo tu selección…';
      this.render();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const reason = typeof result.description === 'string' ? result.description : 'No se ha podido añadir toda la selección.';
          throw new Error(reason);
        }
        this.locked = true;
        if (!this.isConnected) return;
        this.status.textContent = 'Selección añadida. Abriendo ' + (destination === 'checkout' ? 'el checkout…' : 'el carrito…');
        this.navigate(destination);
      } catch (error) {
        // A rejected or interrupted request may already have changed the cart.
        // Do not repeat the POST or assume that nothing was added.
        this.locked = true;
        if (!this.isConnected) return;
        this.status.textContent = '';
        this.error.textContent = (error instanceof TypeError ? 'No hemos podido confirmar la operación.' : error.message) + ' Revisa el carrito antes de continuar. Para hacer una nueva selección, recarga esta página.';
        this.error.hidden = false;
        this.error.focus();
      } finally {
        this.busy = false;
        if (this.isConnected) this.render();
      }
    }
    navigate(destination) {
      if (destination === 'checkout') {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = this.dataset.cartUrl;
        form.hidden = true;
        const checkout = document.createElement('input');
        checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout';
        form.append(checkout);
        document.body.append(form);
        form.submit();
      } else {
        window.location.assign(this.dataset.cartUrl);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
